import url from '../../../../url.js';
export default {
    name: 'ClientView',
    data() {
        return {
            dataClient: [],
            Api: url.URL,
            gambarUrl: url.IMAGE + 'client/',
            titleClient: 'Klien Kami'
        }
    },
    methods: {
        async fetchDataClient() {
            const response = await fetch(this.Api + 'gambar/2');
            const data = await response.json();
            this.dataClient = data;
        }
    },
    mounted() {
        this.fetchDataClient()
    }
}